import React, { Component, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Image,
  Card,
} from "antd";

import logo2 from "../../img/brand/brand.png";

import utils from "../dependencies/custom/react-utilities";
import Settings from "../dependencies/custom/settings";
import Utilities from "../dependencies/custom/react-utilities";
import useWindowDimensions from "../hooks/screensize";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function PassportReset() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { vpWidth, vpHeight } = useWindowDimensions();
  const isMobile = vpWidth <= 768;
  const onFinish = async (values) => {
    setLoading(true);
    const res = await utils.fetchWithAuth(
      "POST",
      Settings.urls.auth.passwordReset,
      values,
      navigate,
    );

    if (res?.ok) {
      Utilities.showNotification(undefined, res?.data?.detail, "text-success");
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
    setLoading(false);
  };

  return (
    <>
      <Layout className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div
            className="sign-up-header mt-5x"
            style={{
              // backgroundImage: `url(${banner2})`,
              background: isMobile
                ? "transparent"
                : "linear-gradient(135deg, #1f1f5d, #00c9a7)",
              height: "300px",
              border: isMobile && "none",
              boxShadow: isMobile && "none",
            }}
          />
          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            title={
              <div className="d-flexx justify-content-centerx">
                <div className="d-flex justify-content-center mt-3">
                  <Image
                    className="mb-2"
                    preview={false}
                    width={Settings?.logoWidth}
                    src={logo2}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center mb-5x text-center">
                  <Title
                    level={5}
                    className="fw-bold text-wrap text-dark"
                    style={{ maxWidth: "90%" }}
                  >
                    Hillside Schools – Naalya
                  </Title>
                </div>
              </div>
            }
            style={{ backgroundColor: "#fafafa" }}
          >
            <Form onFinish={onFinish} layout="vertical" className="row-col">
              <Form.Item
                className="username"
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={loading}
                >
                  Reset
                </Button>
              </Form.Item>

              <p className="font-semibold text-muted">
                Remember Password?{" "}
                <Link to="/signin" className="text-muted font-bold">
                  Sign In
                </Link>
              </p>
            </Form>
          </Card>
        </Content>
      </Layout>
    </>
  );
}
